import { createReducer } from '@reduxjs/toolkit';
import { getAdditionalSettings } from '../../actions/docs';
import { AdditionalSettings } from '../../types/Endpoints/documents/DocumentsContracts';

export interface AdditionalSettingsModel {
  additionalSettings?: AdditionalSettings;
}

export const additionalSettings = createReducer<AdditionalSettingsModel>({ }, builder => {
    builder.addCase(getAdditionalSettings.fulfilled, (state, { payload }) => ({
        ...state,
        additionalSettings: payload,
    }));
});
